import React, { useEffect, useState } from "react";
import UserWrapper from "./user.style";
import PageTitle from "components/common/PageTitle";
import UserForm from "../../components/userModule/UserForm";
import { connect } from "react-redux";
import { addUser, addUserfromAdmin, editUserFromAdmin } from "../../api/index";
import CustomToast from "../../components/customToast/CustomToast";

const UserFromAdminEdit = (props) => {
  const hasCompany_id = props.match.params.hasOwnProperty("company_id");
  let company_id_number;
  if (hasCompany_id) {
    company_id_number = props.match.params.company_id;
  }

  const [editedData, setEditedData] = useState(props.location.state);
  const [toast, showToast] = useState(false);
  const [toastMsg, setMsg] = useState("");

  const hasParam = props.match.params.hasOwnProperty("id");

  useEffect(() => {
    if (hasParam) {
      const data = {
        ...props.location.state,
      };
      setEditedData(data);
    }
  }, []);

  const submitFormHandler = (data, action) => {
    if (action === "add") {
      let apiData = {
        username: data.userName,
        email: data.email,
      };
      props.history.push(`/viewusersfromadmin/${company_id_number}`);
      addUserfromAdmin(apiData, company_id_number).then((res) => {
        if (res && res.status) {
          props.history.push(`/viewusersfromadmin/${company_id_number}`);
        } else {
          if (res) {
            setMsg(res.message);
            showToast(true);
          }
        }
      });
    } else if (action === "edit") {
      let apiData = {
        id: props.location.state.id,
        username: data.userName,
        email: data.email,
      };
      editUserFromAdmin(apiData, company_id_number).then((res) => {
        if (res && res.status) {
          props.history.push(`/viewusersfromadmin/${company_id_number}`);
        } else {
          if (res) {
            setMsg(res.message);
            showToast(true);
          }
        }
      });
    }
  };

  return (
    <UserWrapper {...props}>
      {toast && (
        <CustomToast
          heading={"Alert!"}
          width={400}
          show="bottomRight"
          transition
          position="bottom-right"
          className="c-danger"
          message={toastMsg}
          onCloseCLick={() => showToast(false)}
        />
      )}
      <div className="pos-relative">
        <PageTitle title="User" className="plr-15" iconClass="fas fa-edit" />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() =>
            props.history.push(`/viewusersfromadmin/${company_id_number}`)
          }
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              {/* <span className="hash"># </span> {hasParam ? "Edit" : "Add"} User */}
            </div>
          </div>
          <div className="roe-card-body">
            <UserForm
              onSubmit={submitFormHandler}
              editedData={editedData}
              action={hasParam ? "edit" : "add"}
            />
          </div>
        </div>
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.themeChanger,
  };
};

export default connect(mapStateToProps, null)(UserFromAdminEdit);
